import {
  BOOKMATE_SUFFIX,
  BOOKMATE_SUFFIX_BAR,
} from 'client/shared/constants/metadata'

export const addBMSuffixWhen = (cond: boolean, str: string, bar?: boolean) =>
  str && cond ? `${str}${bar ? BOOKMATE_SUFFIX_BAR : BOOKMATE_SUFFIX}` : str
